import React from 'react';
import { useEffect, useState } from 'react';
import { Button, Table, Radio, Tooltip, Row, Col, Progress, Menu, Dropdown, Modal } from 'antd';
import moment from 'moment'
import './App.less';
var Inflector = require('inflected');
import ContractDetails from './ContractDetails'
import { FaQuestionCircle, FaEthereum, FaBell } from 'react-icons/fa';
import { BellFilled } from '@ant-design/icons';

import Chain from "./Chain"
import * as Fathom from 'fathom-client';
//Fathom.load()
/*
const Address = (props) => <Text color="white" fontSize="md" fontWeight="medium" mr="2">
{props.account &&
  `${props.account.slice(0, 6)}...${props.account.slice(
    props.account.length - 4,
    props.account.length
  )}`}
</Text>*/

const Address = (props) => {
  var link = ''

  if (props.chain == 'ethereum')
    link = 'https://etherscan.io/address/' + props.account;
  if (props.chain == 'polygon')
    link = 'https://polygonscan.com/address/' + props.account;
  if (props.chain == 'optimism')
    link = 'https://optimistic.etherscan.io/address/' + props.account;
  if (props.chain == 'stacks')
    link = 'https://explorer.stacks.co/address/' + props.account + "?chain=mainnet";
    if (props.chain == 'fantom')
    link = 'https://ftmscan.com/address/' + props.account ;
    if (props.chain == 'arbitrum')
    link = 'https://arbiscan.io/address/' + props.account ;
    if (props.chain == 'arbitrum-test')
    link = 'https://testnet.arbiscan.io/address/' + props.account ;
    if (props.chain == 'avalanche')
    link = 'https://snowtrace.io/address/' + props.account ;
    if (props.chain == 'metis')
    link = 'https://andromeda-explorer.metis.io/address/' + props.account ;
    if (props.chain == 'harmony')
    link = 'https://explorer.harmony.one/address/' + props.account ;

  return (
    <a href={link} target="_blank">
      {props.account &&
        `${props.account.slice(0, 6)}...${props.account.slice(
          props.account.length - 4,
          props.account.length
        )}`}
    </a>
  );
}

const getCurrency = (chain) => {
  if (chain == 'ethereum')
    return <span>Ξ</span>
  if (chain == 'polygon')
    return <span>MATIC</span>
  if (chain == 'optimism')
    return <span>Ξ</span>
}

const columns = (chain, hours) => {
  let _columns = [
    {
      title: 'Contract',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Project',
      dataIndex: 'project',
      key: 'project',
      render: txt => txt ? <div>{Inflector.camelize(txt)}</div> : null
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      render: txt => {
        const address = txt.replace('\\', '0');

        //return <a href={link} target="_blank"><Address account={address} /></a>
        return <Address account={address}
          chain={chain}
        />
      }
    },
    {
      title: 'Tx Count',
      dataIndex: 'txc',
      key: 'txc',
    },
    /*
    {
      title: 'Value Sent',
      dataIndex: 'amount',
      key: 'amount',
      render: amt => <div>{amt} {getCurrency(chain)}</div>
    },*/
    {
      title: 'Unique Addresses',
      dataIndex: 'unique_addresses',
      key: 'unique_addresses',
    }
  ];
  if (chain == 'ethereum') {
    /*
    _columns.push({
      title: <div>Trust Score <Tooltip placement="bottom" title="Automated audit checks by TokenSniffer.com">
        <FaQuestionCircle />
      </Tooltip>
      </div>,
      dataIndex: 'trustScore',
      key: 'trustScore',
      render: score => chain == 'ethereum' && score != null ?
        <Progress width={24} type="circle" percent={score} format={(s) => s} /> : <span>N/A</span>
      //showInfo={true}

    })*/
  }
  _columns.push({
    title: 'Deployed',
    dataIndex: 'created_at',
    key: 'created_at',
    render: date =>
      <Tooltip placement="bottom" title={date}>

        <div>{hours > 24 ? moment(date).fromNow() : moment().diff(moment(date), "hours") + ' hrs ago'}</div>
      </Tooltip>

    //moment().diff(moment('2021-12-07T12:04:39+00:00'), "hours")
    //<div>{moment().diff(moment(date), "hours")} hours ago</div>

  })
  return _columns

};

function App() {
  const [loading, setLoading] = useState(false);

  const [loadingCD, setLoadingCD] = useState(false);
  /*
  const [contractDetails, setContractDetails] = useState({
    type: null, //asset_contract_type
    schema_name: null,
    symbol: null,
    total_supply: null,
    description: null,
    external_link: null,
    image_url: null,
    collection: {},

  });*/
  const [contractDetails, setContractDetails] = useState([]);

  const [contracts, setContracts] = useState(null);
  const [hours, setHours] = useState("24");
  const onHrChange = e => {
    //console.log('radio checked', e.target.value);
    setHours(e.target.value);
    fetchContracts(e.target.value, chain);
    Fathom.trackPageview();
  };

  const [chain, setChain] = useState('ethereum');
  const onChainChange = ({key}) => {
    //console.log('radio checked', e.target.value);
    setChain(key);
    fetchContracts(hours, key);
    Fathom.trackPageview();
  };

  const fetchContracts = async (hours, chain) => {
    setLoading(true)
    const res = await fetch('/api?hours=' + hours + '&chain=' + chain);
    const tmp = await res.json();
    //console.log({ tmp })
    setContracts(tmp.records);
    setLoading(false)

  }

  useEffect(() => {
    fetchContracts(hours, chain);
    /* prod */
    Fathom.load('OYUQSHEW', {
      includedDomains: ['hotcontracts.app', 'localhost'],
      url: 'https://graceful-generous.hotcontracts.app/script.js'
    });
  }, []);

  const _columns = columns(chain, hours);
  const onChainClick = ({ key }) => {
    //alert(key)
    setChain(key)
    //message.info(`Click on item ${key}`);
  };

  const menu = (
    <Menu onClick={onChainChange}>
      <Menu.Item key="ethereum" icon={<Chain.Logo chain="ethereum" />}>
        &nbsp; Ethereum
      </Menu.Item>
      <Menu.Item key="polygon" icon={<Chain.Logo chain="polygon" />}>
        &nbsp; Polygon
      </Menu.Item>
      <Menu.Item key="arbitrum" icon={<Chain.Logo chain="arbitrum" />}>
        &nbsp; Arbitrum
      </Menu.Item>
      <Menu.Item key="stacks" icon={<Chain.Logo chain="stacks" />}>
        &nbsp; Stacks
      </Menu.Item>
      <Menu.Item key="fantom" icon={<Chain.Logo chain="fantom" />}>
        &nbsp; Fantom
      </Menu.Item>
      <Menu.Item key="avalanche" icon={<Chain.Logo chain="avalanche" />}>
        &nbsp; Avalanche
      </Menu.Item>
      <Menu.Item key="metis" icon={<Chain.Logo chain="metis" />}>
        &nbsp; Metis
      </Menu.Item>
      <Menu.Item key="harmony" icon={<Chain.Logo chain="harmony" />}>
        &nbsp; Harmony
      </Menu.Item>
    </Menu>
  );

  const clickedAlerts = (e) => {
    showModal(true);

  }
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
    Fathom.trackGoal('MYAYUFTM', 0);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };



  return (
    <main>
      <h1>🔥 Hot Contracts</h1>
      <Row>
        <Col span={12}>
          <div style={{ textAlign: "left" }}>
            Chain: <br />
            <Dropdown.Button overlay={menu}>
              <Chain.Full chain={chain} />
            </Dropdown.Button>
&nbsp;&nbsp;
            <Button onClick={clickedAlerts} icon={<BellFilled />}>
      Alerts
    </Button>
    <Modal title="Create Alerts" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
      <Row>
        <Col span={8} ><center><BellFilled style={{fontSize:90, color: '#c5c251'}} /></center></Col>
        <Col span={16} ><p>We're discussing how to roll this feature...</p>
        <p>Wanna join and discuss?</p>
        <p><a target="_blank" href="https://discord.gg/Z8wG6muCzG">Discord</a></p>
        </Col>
      </Row>
        
      </Modal>

          </div>
        </Col>
        <Col span={12}><div style={{ textAlign: "right" }}>
          Show contracts deployed in last: <Radio.Group onChange={onHrChange} value={hours} defaultValue="24"
          //onChange={this.handleSizeChange}
          >
            <Radio.Button value="1" >1 hr</Radio.Button>
            <Radio.Button value="4" >4 hours</Radio.Button>
            <Radio.Button value="12" >12 hours</Radio.Button>
            <Radio.Button value="24">24 hours</Radio.Button>
            <Radio.Button value="168">7 days</Radio.Button>
          </Radio.Group>

        </div></Col>
      </Row><br />



      <Table
        dataSource={contracts}
        /*
        dataSource={
          [
            {"address":"0xe106c63e655df0e300b78336af587f300cff9e76","amount":2354.4,"block_number":13951539,
            "created_at":"2022-01-06T11:20:03+00:00","name":"OxyaOriginProject (OXYA)","project":null,"txc":8345,
            "unique_addresses":4770,"trustScore":70},
          ]}*/
        columns={_columns} pagination={false}
        loading={loading}
        rowKey={(r) => {
          if (typeof r.block_number != 'undefined')
            return chain + hours + r.address + '-' + r.block_number
          return chain + hours + r.address
        }}
        expandable={{
          expandedRowRender: record =>
            <div style={{ margin: 0 }}>
              <ContractDetails address={record.address} />

            </div>,
          rowExpandable: record => chain == 'ethereum' ? true : false,
        }}
      />

<br/><br/>
<footer>
  <a target="_blank" href="https://twitter.com/hotcontracts">Twitter</a> | &nbsp;
  <a target="_blank" href="https://discord.gg/Z8wG6muCzG">Discord</a>

</footer>
    </main>
    
  );
}

export default App;
